export function convertModuleName(module) {
  if (!module) return module;
  return module.split(/(?=[A-Z])/).join(' ');
}

export function getModuleName(location) {
  const pathname = location && location.pathname ? location.pathname : '';
  const args = pathname.split('/');
  let module, submodule, subtitle, modtitle;
  if (
    (pathname.endsWith('/') && args.length === 6) ||
    (!pathname.endsWith('/') && (args.length === 5 || args.length === 7))
  ) {
    module = args[1];
    submodule = args[2];
    modtitle = convertModuleName(args[1]);
    subtitle = convertModuleName(args[2]);
  } else {
    module = args[1];
    modtitle = convertModuleName(args[1]);
  }
  return { module, submodule, modtitle, subtitle };
}

export function getFormModuleName(location, params) {
  const pathname = location && location.pathname ? location.pathname : '';
  const args = pathname.split('/');
  let module, submodule, subtitle, modtitle;

  let paramCount = params ? Object.keys(params).length : 1;

  if (args.length >= 5 + paramCount) {
    module = args[1];
    submodule = args[2];
    modtitle = convertModuleName(args[1]);
    subtitle = convertModuleName(args[2]);
  } else {
    module = args[1];
    modtitle = convertModuleName(args[1]);
  }
  return { module, submodule, modtitle, subtitle };
}
